import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var api__createTamaraRemainingCheckout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(requestData) {
    var response;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().post("/tamara/checkout-remaining-payment", requestData);
        case 1:
          response = _context.v;
          return _context.a(2, response.data);
      }
    }, _callee);
  }));
  return function api__createTamaraRemainingCheckout(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__tamaraPreScoringRemaining = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requestData) {
    var response;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetcher().post("/tamara/pre-scoring-remaining", requestData);
        case 1:
          response = _context2.v;
          return _context2.a(2, response.data);
      }
    }, _callee2);
  }));
  return function api__tamaraPreScoringRemaining(_x2) {
    return _ref2.apply(this, arguments);
  };
}();